import React, {useCallback, useEffect, useRef, useState} from "react";
import {inject, observer} from "mobx-react";
import {QRCodeSVG} from "qrcode.react";
import {useTranslation} from "react-i18next";
import {Preloader} from "components/Preloader";
import {showSuccess} from "helpers/notifications.helper";
import {getMessage} from "helpers/helper";

export const ModalIdentifyContractPerson = inject("store")(
  observer(({store: {auth, buyer}}) => {
    const {t} = useTranslation();
    const {qrCodeData} = auth;
    const {currentRequest} = buyer;
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);
    const userMessage = auth.bankIdVerifyData?.userMessage;
    const COUNTDOWN_START = 300; // 5 minutes in seconds
    const [timeLeft, setTimeLeft] = useState(COUNTDOWN_START);

    useEffect(() => {
      auth.getBankIdDataOnContract();
      intervalRef.current = setInterval(() => {
        auth.getBankIdQRCodeOnContract();
      }, 1000);

      const countdownInterval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);

            auth.cancelAuthBankId();
            auth.setBankIdVerifyData({});
            auth.updateAuthModalName(null);

            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (intervalRef.current) clearInterval(intervalRef.current);
      };
    }, [auth]);

    useEffect(() => {
      if (auth.bankIdVerifyData?.hintCode === "startFailed") {
        auth.getBankIdDataOnContract();

        if (intervalRef.current) clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
          auth.getBankIdQRCodeOnContract();
        }, 1000);
      }
    }, [auth, auth.bankIdVerifyData?.hintCode]);

    const checkBankIdStatus = useCallback(() => {
      if (auth.bankIdVerifyData?.id) {
        return;
      }

      switch (auth.bankIdVerifyData?.status) {
        case "failed":
          if (auth.bankIdVerifyData?.hintCode === "startFailed") {
            return getMessage(userMessage);
          }

          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }

          timeoutRef.current = setTimeout(() => {
            auth.updateAuthModalName(null);
            auth.setBankIdVerifyData({});
          }, 3000);

          return getMessage(userMessage);

        case "complete":
          showSuccess(t("VERIFICATION_COMPLETED"));
          auth.updateAuthModalName(null);
          return null;

        default:
          return getMessage(userMessage);
      }
    }, [auth, t, userMessage]);

    const formatTime = (seconds) => {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

    return (
      <div className="modal-auth modal-identify_wrapper">
        <div className="modal-identify_image">
          {qrCodeData ? (
            <div>
              <button
                style={{border: "none", background: "none"}}
                onClick={() =>
                  document
                    .querySelector(".modal-ent__wrapper")
                    .classList.add("fullscreen")
                }
              >
                <QRCodeSVG value={qrCodeData} size={180} />
              </button>
              <div className="modal-identify_timer">
                {t("TIME_LEFT")}: {formatTime(timeLeft)}
              </div>
            </div>
          ) : (
            <Preloader addClass="preloader500" />
          )}
        </div>
        <p className={`modal-identify_text ${qrCodeData ? "mb-2" : "mb-12"}`}>
          {checkBankIdStatus()}
        </p>

        {qrCodeData && (
          <a
            href={`bankid:///?autostarttoken=${auth.autoStartToken}&redirect=${window.location.origin}/requests/${currentRequest.id}`}
            className="modal-identify_link mb-12"
          >
            {t("OPEN_BANK_ID_LINK")}
          </a>
        )}
      </div>
    );
  })
);
